import styled from 'styled-components';

import { Loader } from 'components/Loader';
import { OpsParameterForm } from './components/OpsParameterForm';

import { useOpsParametersQuery } from 'data/__generated__';

export const OpsParameters = () => {
    const {
        loading: opsParametersLoading,
        error: opsParametersError,
        data: opsParametersData,
    } = useOpsParametersQuery();

    if (opsParametersLoading) {
        return (
            <Container>
                <Loader />
            </Container>
        );
    }

    if (!opsParametersData || opsParametersError) {
        throw new Error('Une erreur est survenue lors de la récupération des opsParameters');
    }

    const { opsParameters } = opsParametersData;

    return (
        <Container>
            <OpsParameterForm opsParameter={opsParameters} />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;
